import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { HttpErrorResponse } from "../../../types/responses";
import { assigneePaginationFilterParam } from "../../../types/params";
import { useApiPssFindIncludeGetUserAssignee } from "../datasources/_pss.assignee-details.api.slice";

const usePssAprsFindIncludeGetUserAssigneeRepo = (
  filter?: assigneePaginationFilterParam,
) => {
  const { isSuccess, data, isError, error, isLoading, refetch } =
    useApiPssFindIncludeGetUserAssignee(filter);

  const httpError = error
    ? ((error as FetchBaseQueryError).data as HttpErrorResponse)
    : undefined;

  if (!isLoading) {
  }

  return {
    state: {
      isSuccess,
      userAssignee: data,
      isError,
      error: httpError,
      isLoading,
    },
    action: {
      refetch,
    },
  };
};

export default usePssAprsFindIncludeGetUserAssigneeRepo;
